import { LabsCard } from "../LabsCard.tsx";
import { Button, Typography, Box } from "@mui/material";
import { Link, useOutletContext } from "react-router";
import { DashboardPanelOutlet } from "../../types/DashboardPanelOutlet.ts";
import { green, orange } from "@mui/material/colors";

export const ReviewAndAdjustPanel = () => {
  const { planOnTrack } = useOutletContext<DashboardPanelOutlet>();
  return (
    <LabsCard>
      <Typography variant={"h6"} color={"primary.dark"}>
        Review & Adjust
      </Typography>
      <Typography variant={"body1"}>
        {planOnTrack ? (
          <Box component={"span"}>
            Your plan is{" "}
            <Box component={"span"} sx={{ color: green[600] }}>
              on track
            </Box>{" "}
            to meet your target. View customized recommendations to make it more
            cost-effective.
          </Box>
        ) : (
          <Box component={"span"}>
            Your plan is{" "}
            <Box component={"span"} sx={{ color: orange[700] }}>
              off track
            </Box>{" "}
            to meet your target. Get on track with our customized
            recommendations.
          </Box>
        )}
      </Typography>
      <Button
        variant={planOnTrack ? "contained" : "outlined"}
        component={Link}
        to={"email-plan"}
      >
        Get your plan
      </Button>
      <Button
        variant={planOnTrack ? "outlined" : "contained"}
        component={Link}
        to={"recommendations"}
      >
        Recommendations
      </Button>
    </LabsCard>
  );
};
